const prefixCls = 'web.common.';

export const localesCommon = {
  // 通用文本
  [prefixCls + 'general.all']: {
    zh_CN: '全部',
    en_GB: 'All',
  },
  [prefixCls + 'general.confirmDelete']: {
    zh_CN: '确定要删除此账号吗？此操作不可恢复。',
    en_GB:
      'Are you sure you want to delete this account? This action cannot be undone.',
  },
  [prefixCls + 'general.noData']: {
    zh_CN: '暂无数据',
    en_GB: 'No Data',
  },
  [prefixCls + 'general.loading']: {
    zh_CN: '加载中...',
    en_GB: 'Loading...',
  },
  [prefixCls + 'general.error']: {
    zh_CN: '发生错误',
    en_GB: 'An error occurred',
  },

  // 按钮文本
  [prefixCls + 'button.save']: {
    zh_CN: '保存',
    en_GB: 'Save',
  },
  [prefixCls + 'button.cancel']: {
    zh_CN: '取消',
    en_GB: 'Cancel',
  },
  [prefixCls + 'button.confirm']: {
    zh_CN: '确认',
    en_GB: 'Confirm',
  },
  [prefixCls + 'button.delete']: {
    zh_CN: '删除',
    en_GB: 'Delete',
  },
  [prefixCls + 'button.edit']: {
    zh_CN: '编辑',
    en_GB: 'Edit',
  },
  [prefixCls + 'button.search']: {
    zh_CN: '搜索',
    en_GB: 'Search',
  },
  [prefixCls + 'button.reset']: {
    zh_CN: '重置',
    en_GB: 'Reset',
  },
  [prefixCls + 'button.more']: {
    zh_CN: '更多',
    en_GB: 'More',
  },
  [prefixCls + 'button.refresh']: {
    zh_CN: '数据更新',
    en_GB: 'Refresh',
  },
  [prefixCls + 'button.submit']: {
    zh_CN: '提交',
    en_GB: 'Submit',
  },
  [prefixCls + 'button.back']: {
    zh_CN: '返回',
    en_GB: 'Back',
  },
  [prefixCls + 'button.backToParent']: {
    zh_CN: '返回',
    en_GB: 'Back to Parent',
  },

  // 动作文本
  [prefixCls + 'action.search']: {
    zh_CN: '搜索',
    en_GB: 'Search',
  },
  [prefixCls + 'action.edit']: {
    zh_CN: '编辑',
    en_GB: 'Edit',
  },

  // 表格相关
  [prefixCls + 'table.action']: {
    zh_CN: '操作',
    en_GB: 'Action',
  },
  [prefixCls + 'table.empty']: {
    zh_CN: '暂无数据',
    en_GB: 'No Data',
  },

  // 分页相关
  [prefixCls + 'pagination.total']: {
    zh_CN: '共 {total} 条',
    en_GB: 'Total {total} items',
  },

  // 日期相关
  [prefixCls + 'date.start']: {
    zh_CN: '开始日期',
    en_GB: 'Start Date',
  },
  [prefixCls + 'date.end']: {
    zh_CN: '结束日期',
    en_GB: 'End Date',
  },
  [prefixCls + 'date.range']: {
    zh_CN: '日期范围',
    en_GB: 'Date Range',
  },
  [prefixCls + 'date.today']: {
    zh_CN: '今天',
    en_GB: 'Today',
  },
  [prefixCls + 'date.yesterday']: {
    zh_CN: '昨天',
    en_GB: 'Yesterday',
  },
  [prefixCls + 'date.thisWeek']: {
    zh_CN: '本周',
    en_GB: 'This Week',
  },
  [prefixCls + 'date.lastWeek']: {
    zh_CN: '上周',
    en_GB: 'Last Week',
  },
  [prefixCls + 'date.thisMonth']: {
    zh_CN: '本月',
    en_GB: 'This Month',
  },
  [prefixCls + 'date.lastMonth']: {
    zh_CN: '上月',
    en_GB: 'Last Month',
  },

  // 状态相关
  [prefixCls + 'status.active']: {
    zh_CN: '活跃',
    en_GB: 'Active',
  },
  [prefixCls + 'status.inactive']: {
    zh_CN: '非活跃',
    en_GB: 'Inactive',
  },
  [prefixCls + 'status.pending']: {
    zh_CN: '待处理',
    en_GB: 'Pending',
  },
  [prefixCls + 'status.processing']: {
    zh_CN: '处理中',
    en_GB: 'Processing',
  },
  [prefixCls + 'status.completed']: {
    zh_CN: '已完成',
    en_GB: 'Completed',
  },
  [prefixCls + 'status.failed']: {
    zh_CN: '失败',
    en_GB: 'Failed',
  },

  // 表单相关
  [prefixCls + 'form.required']: {
    zh_CN: '必填项',
    en_GB: 'Required',
  },
  [prefixCls + 'form.optional']: {
    zh_CN: '选填',
    en_GB: 'Optional',
  },
  [prefixCls + 'form.invalid']: {
    zh_CN: '无效输入',
    en_GB: 'Invalid input',
  },
  [prefixCls + 'detail']: {
    zh_CN: '详情',
    en_GB: 'Detail',
  },
};
